import { render, staticRenderFns } from "./ConveniosCotasEdit.vue?vue&type=template&id=6cc3662c&scoped=true&"
import script from "./ConveniosCotasEdit.vue?vue&type=script&lang=js&"
export * from "./ConveniosCotasEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc3662c",
  null
  
)

export default component.exports